import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const WNI_FEATURES = 'featureLookupWNI';

export default class WNIFeatureService {

    static isFeatureEnabled(feature, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(WNI_FEATURES), 'isFeatureEnabled', [feature], additionalHeaders);
    }

    static getAllFeatures(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl(WNI_FEATURES), 'getAllFeatures',[], additionalHeaders);
    }
}